import {expressEventListener} from "../common/html";
import {ShowContentDialog} from "./content-dialog";

export function createPopupLauncher(el: HTMLElement) {
	const dialogId = el.dataset.dialogid || '';
	const contentKey = el.dataset.label || '';
	if (dialogId && contentKey) {
		const onClick = (e:MouseEvent) => {
			e.preventDefault();
			ShowContentDialog({dialogId: dialogId, label: contentKey});
		}; 
		expressEventListener(el, 'click', onClick);
	}
}
